import React from 'react';
import PropTypes from 'prop-types';

const Breadcrumb = ({ title, description, renderRight, renderLeft, image }) => (
  <section className="header-content">
    {renderLeft}
    <div className="bx--row">
      <div className="bx--col-xs-12 flexible">
        {image && <div className="image" style={{ backgroundImage: `url(${image})` }} />}
        <h2 className="title">{title}</h2>
        <h3 className="subtitle">{description}</h3>
      </div>
      {renderRight}
    </div>
  </section>
);

Breadcrumb.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  
  renderRight: PropTypes.node,
  renderLeft: PropTypes.node,
};
Breadcrumb.defaultProps = {
  description: '',
  renderRight: null,
  renderLeft: null,
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js